import './vendor';
import './helpers';
import './analytics';
import './blocks';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';

ieFix();
vhFix();
